import { render, staticRenderFns } from "./GenreOnboarding.vue?vue&type=template&id=869a1d84"
import script from "./GenreOnboarding.vue?vue&type=script&lang=js"
export * from "./GenreOnboarding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports